import apiFactory from '@/api/default';

const API = apiFactory('files');

const state = {
  filesSearchResults: [],
  currentFile: undefined,
};

const getters = {
  filesSearchResults: (state) => state.filesSearchResults,
  currentFile: (state) => state.currentFile,
};

const mutations = {
  setFilesSearchResults: (state, filesSearchResults) => {
    state.filesSearchResults = filesSearchResults;
  },
  setCurrentFile: (state, currentFile) => {
    state.currentFile = currentFile;
  },
};

const actions = {
  async loadFile({commit}, data) {
    const response = await API.load(data.id, data.query);
    commit('setCurrentFile', response.data);
    return response.data;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
